import '../tab-nav/tab-nav.scss';

import { useContext } from 'react';
import classNames from 'classnames';
import { Link, useMatch } from 'react-router-dom';
import { TenantContext } from '../../context/tenant-context';
import { Divider } from '../divider/divider';

// Utility function to convert string to camel case
const toCamelCase = (str: string): string => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
};

export const RouteTabs = ({ tabNames, path }: { tabNames: string[]; path: string }) => {
  const { contextPath } = useContext(TenantContext);
  const match = useMatch(`${contextPath}manager${path}/:tab`);
  const selectedTab = match?.params.tab;

  return (
    <div className="tab-nav">
      <nav className="tabs !px-4">
        {tabNames.map((tab, i) => {
          const camelCaseTab = toCamelCase(tab);
          return (
            <Link
              to={camelCaseTab}
              key={i}
              className={classNames('tab !py-3', {
                selected:
                  selectedTab && selectedTab.localeCompare(camelCaseTab, undefined, { sensitivity: 'accent' }) === 0,
              })}
            >
              {tab}
            </Link>
          );
        })}
      </nav>

      <Divider />
    </div>
  );
};
